import { render, staticRenderFns } from "./ArtworksTextNoteToggleButton.vue?vue&type=template&id=2579332e"
import script from "./ArtworksTextNoteToggleButton.vue?vue&type=script&lang=js"
export * from "./ArtworksTextNoteToggleButton.vue?vue&type=script&lang=js"
import style0 from "./ArtworksTextNoteToggleButton.vue?vue&type=style&index=0&id=2579332e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports